import store  from '../store';
import db from '@/plugins/dexie';
import { TOKEN, VENDEDOR_STORAGE } from '@/constants/STORAGE'

function getSessionStorage(key,defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}
export default async function conexao() {
  // Login do Usuário caso se conectou offline.
  const authToken = getSessionStorage(TOKEN, '');
  const venridnuvem = getSessionStorage(VENDEDOR_STORAGE.venidnuvem,'');
  const payload = await db.vendedor.where({venidnuvem: venridnuvem}).first();
  if(!authToken) {
    try {
      const vendedor = {
        cpf: payload.vendedorcpf,
        password: payload.vensenha,
      }
      store.dispatch('auth/authenticate', vendedor)
      
    } catch (err) {
      console.log(err)
    }
  }
}
